import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const TraditionalRentalSummary = ({ investorResult }) => {
  if (!investorResult) {
    return <div className="text-center text-gray-500">No data available for Traditional Rental.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-0 w-full">
      <h2 className="text-2xl font-bold text-center text-blue-700 mb-6">Traditional Rental Summary</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 px-2">
        {/* Investor Summary */}
        <div className="bg-gray-50 rounded-md p-4 md:p-5">
          <h3 className="text-green-700 text-xl font-semibold text-center mb-4">Investor Summary</h3>
          <div className="grid gap-y-2 text-sm" style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
            <div>Capital Invested:</div>
            <div className="font-semibold">{formatCurrency(investorResult.originalPropertyValue)}</div>

            <div>Total Gross Rent:</div>
            <div className="font-semibold">{formatCurrency(investorResult.cumulativeGrossRent)}</div>

            <div>Vacancy Loss:</div>
            <div className="font-semibold text-red-600">−{formatCurrency(investorResult.totalVacancyLoss)}</div>

            {/* <div>Admin Fee Paid (Total):</div>
            <div className="font-semibold text-red-600">−{formatCurrency(investorResult.totalAdminFees)}</div> */}

            <div>Total Expenses (Tax + Insurance + Maintenance + Admin):</div>
            <div className="font-semibold text-red-600">−{formatCurrency(investorResult.cumulativeExpenses)}</div>

            <div>Net Cashflow (After Expenses & Vacancy):</div>
            <div className="font-semibold">{formatCurrency(investorResult.netCashflow)}</div>

            <div>Final Asset Value:</div>
            <div className="font-semibold">{formatCurrency(investorResult.finalValue)}</div>

            <div>Sell Cost (Agent, Closing, etc):</div>
            <div className="font-semibold text-red-600">−{formatCurrency(investorResult.sellCost)}</div>

            <div>Net Asset Value After Sale:</div>
            <div className="font-semibold">{formatCurrency(investorResult.netAssetValueAfterSale)}</div>

            <div>Exit Value (Net Cashflow + Net Sale Value):</div>
            <div className="font-semibold">{formatCurrency(investorResult.exitValue)}</div>

            <div>Final Net Profit (Exit − Initial Investment):</div>
            <div className="font-semibold text-green-700">{formatCurrency(investorResult.finalNetProfit)}</div>

            <div>Cash-on-Cash Return:</div>
            <div className="font-semibold">{investorResult.cashOnCashReturn}%</div>

            <div>Total ROI:</div>
            <div className="font-semibold">{investorResult.totalROI}%</div>

            <div>Annualized ROI:</div>
            <div className="font-semibold">{investorResult.annualizedROI}%</div>

            <div>IRR Estimate:</div>
            <div className="font-semibold">{investorResult.irrEstimate}%</div>

            <div>Annual NOI:</div>
            <div className="font-semibold">{formatCurrency(investorResult.annualNOI)}</div>

            <div>Cap Rate:</div>
            <div className="font-semibold">{investorResult.capRate}%</div>

            <div>Investment Term:</div>
            <div className="font-semibold">{investorResult.termYears} years</div>
          </div>

          <p className="text-xs text-gray-600 mt-4 text-center">
            * Exit value includes rent income and final asset value after all expenses, admin fees, vacancy losses, and selling costs.
          </p>
        </div>

        {/* Entrepreneur Section */}
        <div className="bg-gray-50 rounded-md p-4 md:p-5 flex flex-col justify-between">
          <div>
            <h3 className="text-purple-700 text-xl font-semibold text-center mb-4">Entrepreneur (Renter)</h3>
            <div className="grid gap-y-2 text-sm" style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              <div>First Month Rent:</div>
              <div className="font-semibold">{formatCurrency(investorResult.firstYearRent / 12)}</div>

              <div>Last Month Rent:</div>
              <div className="font-semibold">{formatCurrency(investorResult.lastYearRent / 12)}</div>

              <div>Total Rent Paid Over Term:</div>
              <div className="font-semibold">{formatCurrency(investorResult.totalBorrowerPaid)}</div>

              <div>Equity Built:</div>
              <div className="font-semibold">0%</div>
            </div>
          </div>
          <p className="text-xs text-gray-600 mt-4 text-center leading-snug">
            * In traditional rental models, renters do not gain equity or ownership benefits — rent is purely an expense.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TraditionalRentalSummary;
